module.exports = __webpack_public_path__ + "static/media/loc7_img11.6e799050.jpg";